
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('span, h2, h1, h3, h4, h5, h6, p, li').forEach(el => {
    let html = el.innerHTML;

    // Handle triple brackets first (most specific), then double, then single
    html = html.replace(/\[\[\[([^\]]+)\]\]\]/g, '<span class="bracket-highlight-blue">$1</span>');
    html = html.replace(/\[\[([^\]]+)\]\]/g, '<span class="bracket-highlight-purple">$1</span>');
    html = html.replace(/\[([^\]]+)\]/g, '<span class="bracket-highlight">$1</span>');

    el.innerHTML = html;
  });
});
